<template>
    <div class="main Ssdt">
        <Titledx text="热点分类统计" />
        <div class="" id="echart_rdfx"></div>
    </div>
</template>
<script>
import Titledx from "./components/title";
import miment from "miment";
import echarts from "echarts";

export default {
    components: {
        Titledx,
    },
    data() {
        return {
            start: false,
        };
    },
    //     watch: {
    //     data: {
    //       immediate: true,
    //     //   handler() {
    //     //     this.option.series[0].links = this.data.map((item, index) => {
    //     //       let color;
    //     //       switch (item.relations) {
    //     //         case "家人":
    //     //           color = "#d94042";
    //     //           break;
    //     //         case "邻居":
    //     //           color = "#e98e09";
    //     //           break;
    //     //         default:
    //     //           color = "#1fd58a";
    //     //           break;
    //     //       }
    //     //       return {
    //     //         target: index > 0 ? this.data[0].id + "" : "",
    //     //         source: item.id + "",
    //     //         value: item.relations,
    //     //         // lineStyle: {
    //     //         //   color
    //     //         // },
    //     //         label: {
    //     //           backgroundColor: color
    //     //         }
    //     //       };
    //     //     });
    //     //     this.option.series[0].data = this.data.map(item => {
    //     //       let color;
    //     //       switch (item.relations) {
    //     //         case "家人":
    //     //           color = "#d94042";
    //     //           break;
    //     //         case "邻居":
    //     //           color = "#e98e09";
    //     //           break;
    //     //         default:
    //     //           color = "#1fd58a";
    //     //           break;
    //     //       }
    //     //       return {
    //     //         name: item.id + "",
    //     //         symbol:item.photo ? `image://${item.photo}` :
    //     //           item.gender == "男"
    //     //             ? (item.relations == '自己' ? `image://${require("../../../assets/bigdata/avatar_force_default_man_min.png")}` :`image://${require("../../../assets/bigdata/avatar_force_default_man_min.png")}` )
    //     //             : (item.relations == '自己' ?  `image://${require("../../../assets/bigdata/avatar_force_default_women.png")}`:`image://${require("../../../assets/bigdata/avatar_force_default_women_min.png")}`),
    //     //         symbolSize:item.relations == '自己' ? 80 : 60,
    //     //         draggable: false,
    //     //         category: 1,
    //     //         itemStyle: {
    //     //           normal: {
    //     //             borderColor: "#04f2a7",

    //     //             shadowBlur: 20,
    //     //             shadowColor: "#04f2a7",
    //     //             color: "#001c43"
    //     //           }
    //     //         },
    //     //         label: {
    //     //           rich: {
    //     //             name: {
    //     //               fontSize: 14,
    //     //               color: "#a2a7b2",
    //     //               fontFamily: "SourceHanSansCN-Medium"
    //     //             },
    //     //             tag: {
    //     //               fontSize: 12,
    //     //               color: color
    //     //             }
    //     //           },
    //     //           formatter: [
    //     //             `{tag|${item.relations}}`,
    //     //             `{name|${item.name}}`
    //     //           ].join("\n")
    //     //         }
    //     //       };
    //     //     });
    //     //     return;
    //     //   }
    //     }
    //   },
    methods: {
        getToken() {
            let formData = new FormData();
            formData.append("username", "dongxiang");
            formData.append("password", "dxq!@123456@!");
            this.$post(this.urlobj.dx_dl, formData).then((res) => {
                localStorage.token = res.newPrimaryKeys.token;
                this.$store.commit("updateToken", res.newPrimaryKeys.token);
                this.getData();
            });
        },
        getData() {
            let option = {
                series: [
                    {
                        type: "graph",
                        layout: "force",

                        gravity: 100,
                        force: {
                            repulsion: 300,
                            edgeLength: [50,200],
                            layoutAnimation: true,
                        },
                       edgeSymbol: ['circle', 'arrow'],
                        edgeSymbolSize: [2, 2],
                        symbolSize: 50,
                        // symbol: "circle",
                        roam: false,
                        zoom: 0.5,
                        //  grid:{
                        //     top:"0px",
                        //     left:"-1000px",
                        //     right:"-1000px",
                        //     bottom:"0px"
                        // },
                        label: {
                            normal: {
                                show: true,
                                position: "inside",
                                color: "red",
                                fontSize: "12px",
                                align: "center",
                                lineHeight: 18,
                                borderRadius: "50px",
                            },
                        },
                        focusNodeAdjacency: true,
                        data: [],
                        links: [],
                        lineStyle: {
                            normal: {
                                opacity: 0.9,
                                width: 3,
                                curveness: 0,
                                color: "#235787",
                            },
                        },
                    },
                ],
            };
            let colors = [
                "rgba(185, 255, 86, 1)",
                "rgba(111, 233, 255, 1)",
                "rgba(255, 82, 21, 1)",
                "rgba(178, 106, 245, 1)",
                "rgba(255, 198, 0, 1)",
                "rgba(185, 255, 86, 1)",
                "rgba(111, 233, 255, 1)",
                "rgba(255, 82, 21, 1)",
                "rgba(178, 106, 245, 1)",
                "rgba(255, 198, 0, 1)",
                "rgba(185, 255, 86, 1)",
                "rgba(111, 233, 255, 1)",
                "rgba(255, 82, 21, 1)",
                "rgba(178, 106, 245, 1)",
                "rgba(255, 198, 0, 1)",
                "rgba(185, 255, 86, 1)",
                "rgba(111, 233, 255, 1)",
                "rgba(255, 82, 21, 1)",
                "rgba(178, 106, 245, 1)",
                "rgba(255, 198, 0, 1)",
                "rgba(185, 255, 86, 1)",
                "rgba(111, 233, 255, 1)",
                "rgba(255, 82, 21, 1)",
            ];
            let color = [
                "rgba(185, 255, 86, 0.6)",
                "rgba(111, 233, 255, 0.6)",
                "rgba(255, 82, 21, 0.6)",
                "rgba(178, 106, 245, 0.6)",
                "rgba(255, 198, 0, 0.6)",
                "rgba(185, 255, 86, 0.6)",
                "rgba(111, 233, 255, 0.6)",
                "rgba(255, 82, 21, 0.6)",
                "rgba(178, 106, 245, 0.6)",
                "rgba(255, 198, 0, 0.6)",
                "rgba(185, 255, 86, 0.6)",
                "rgba(111, 233, 255, 0.6)",
                "rgba(255, 82, 21, 0.6)",
                "rgba(178, 106, 245, 0.6)",
                "rgba(255, 198, 0, 0.6)",
                "rgba(185, 255, 86, 0.6)",
                "rgba(111, 233, 255, 0.6)",
                "rgba(255, 82, 21, 0.6)",
                "rgba(178, 106, 245, 0.6)",
                "rgba(255, 198, 0, 0.6)",
                "rgba(185, 255, 86, 0.6)",
                "rgba(111, 233, 255, 0.6)",
                "rgba(255, 82, 21, 0.6)",
            ];
            var url = this.urlobj.dx_rdfx + "?type=dxrcfx";
            this.$get(url).then((res) => {
                let data = res.rows[0].data;

                option.series[0].data = data.map((item, index) => {
                    item.dataArr.forEach((itemx) => {
                        itemx.color = color[index];
                    });
                    

                    return {
                        category: 1,
                        draggable: false,
                        name: item.type,

                        symbolSize: 100,
                        label: {
                            show: true,
                            position: "inside",
                            color: color[index],
                        },
                        itemStyle: {
                            color: "transparent",
                            borderColor: color[index],
                            borderWidth: 2,
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 20,
                                shadowColor: colors[index],
                            } 
                        }
                    };
                });
                option.series[0].links = data.map((item, index) => {
                    return { source: item.type, target: "" };
                });

                data.forEach((item) => {
                    item.dataArr.forEach((items, index) => {
                        if (
                            !option.series[0].data.find(
                                (itemxx) => itemxx.name == items.name
                            )
                        ) {
                            option.series[0].data.push({
                                category: 1,
                                draggable: true,
                                name: items.name,
                                symbolSize: 50,
                                label: {
                                    show: true,
                                    position: "inside",
                                    color: items.color,
                                },
                                itemStyle: {
                                    color: "transparent",
                                    borderColor: items.color,
                                    borderWidth: 1,
                                    shadowBlur: 20,
                                    shadowColor: items.color,
                                },
                            });

                            option.series[0].links.push({
                                source: items.name,
                                target: item.type,
                                value: items.count / 100,
                                lineStyle: {
                                    color: items.color,
                                },
                            });
                        }
                    });
                });
            
                var myChart = echarts.init(
                    document.getElementById("echart_rdfx")
                );
                
                let x = []
                option.series[0].data.forEach(item=>{
                    if(item.name !='联通公司'&&item.name !='电信公司'&&item.name !='突发事件') {
                        x.push(item)
                    }
                })
                option.series[0].data = x
                let y = []
                option.series[0].links.forEach(item=>{
                    if(item.source !='联通公司'&&item.source !='电信公司'&&item.source !='突发事件') {
                        y.push(item)
                    }
                })
                option.series[0].links = y

                myChart.setOption(option);
            });

            console.log(option);
        },
    },
    watch: {},
    created() {},
    mounted() {
         if(this.$store.state.access_token){
            this.getData();
        }else{
            this.getToken();
        }

        // document.getElementsByClassName("Ssdt")[0].style.zoom = 0.5;
        // let huanjing = window.location.href.split("//")[1].split("/")[0];
        // console.log(huanjing);
        // window.btnclick = function (type) {
        //     if (type == "goback") {
        //         if (huanjing == "ct.shequyun.cn") {
        //             window.open(
        //                 "https://ceshi.shequyun.cn/#/moduleList",
        //                 "_self"
        //             );
        //         } else {
        //             window.open(`https://${huanjing}/#/moduleList`, "_self");
        //         }
        //     }
        // };
    },
};
</script>
<style lang="less" scoped>
.main{
    overflow: hidden;
}
#echart_rdfx {
    margin: 50px 0;
    height: 770px;
    width: 100%;
}
</style>